// extracted by mini-css-extract-plugin
module.exports = {"single":"posts-module--single--6fvum","title":"posts-module--title--2B7RC","meta":"posts-module--meta--3PxMn","tag":"posts-module--tag--1J-Zk"};